var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usernames",staticStyle:{"margin-top":"-35px"}},[_c('Usernames',{attrs:{"scoped":{contact_id_in: [this.$route.params.id]}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }